import React from "react";

import Header from "../../../UI/Header";

const HeaderWrapper = () => <Header header="Timeline" />;

export default HeaderWrapper;
